import { render, staticRenderFns } from "./step-description-grades.vue?vue&type=template&id=7d6f5840"
import script from "./step-description-grades.vue?vue&type=script&lang=ts"
export * from "./step-description-grades.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports